export const FIELDS = Object.freeze({
  TITLE: 'title',
  ABOUT: 'about',
  DURATION: 'duration',
  PAGES: 'pages',
  TAGS: 'tags',
  THUMBNAIL_LINK: 'thumbnailLink',
  PRODUCTS: 'products',
  INSTRUCTOR: 'instructor',
  FILE_TYPE: 'fileType',
  FILE_URL: 'fileUrl',
  CATEGORY: 'category',
  RELATED: 'related',
  DATE_ONLY: 'dateOnly',
});


export const DATE_FORMAT_OPTIONS = Object.freeze({
  year: 'numeric',
  month: 'long',
  day: 'numeric',
});

export const API_KEYS = Object.freeze({
  FILE_TYPE_SNAKE: 'file_type',
  FILE_URL_SNAKE: 'file_url',
  THUMNAIL_LINK_LEGACY: 'thumnailLink', // note the legacy misspelling kept intentionally
  THUMBNAIL_LINK: 'thumbnailLink',
});

export const FILE_TYPE = Object.freeze({
  VIDEO: 'video',
  PDF: 'pdf',
});

export const FILE_TYPE_OPTIONS = Object.freeze([
  { value: FILE_TYPE.VIDEO, label: 'Video' },
  { value: FILE_TYPE.PDF, label: 'PDF' },
]);

export const UI_LABELS = Object.freeze({
  PAGE_TITLE_CREATE: 'Add Content',
  PAGE_TITLE_EDIT: 'Edit Content',
  TITLE: 'Title',
  ABOUT: 'About',
  TAGS: 'Tags',
  PRODUCTS: 'Products',
  INSTRUCTOR: 'Instructor',
  CATEGORY: 'Category',
  RELATED_VIDEOS: 'Related Videos',
  THUMBNAIL_URL: 'Thumbnail URL',
  FILE_TYPE: 'File Type',
  PDF_URL: 'PDF URL',
  DURATION: 'Duration (seconds)',
  PAGES: 'Pages (auto-detected)',
  RELEASE_DATE: 'Release Date',
  PAGES_HELPER: 'Will auto-detect from PDF when possible; you can override.',
  BTN_SAVE: 'Save',
  BTN_UPDATE: 'Update',
  BTN_RESET: 'Reset',
  VIDEO_OVERLAY: 'Processing video… This can take a few minutes.',
  LOADING: 'Loading content...',
});

export const LIST_LABELS = Object.freeze({
  TITLE: 'TRC Content List',
  ADD: UI_LABELS.PAGE_TITLE_CREATE, 
  INSTRUCTOR: UI_LABELS.INSTRUCTOR, 
  TYPE: UI_LABELS.FILE_TYPE,        
  DATE_CREATED: 'Date Created',
  DATE_RELEASED: 'Date Released',
});

export const MESSAGES = Object.freeze({
  SUCCESS_CREATE: 'Content added successfully.',
  SUCCESS_EDIT: 'Content updated successfully.',
  ERROR_GENERIC: 'Something went wrong. Please try again.',
  ERROR_TITLE_REQUIRED: 'Title is required',
  ERROR_ABOUT_REQUIRED: 'About is required',
  ERROR_FILETYPE_REQUIRED: 'File type is required',
  ERROR_VIDEO_EMPTY: 'Please upload the video via Mux and wait until it is processed.',
  ERROR_DURATION_INVALID: 'Duration (in seconds) must be a positive number.',
  ERROR_PDF_EMPTY: 'Please upload a PDF or paste a PDF URL.',
  ERROR_PAGES_INVALID: 'Could not detect valid page count. Please ensure the PDF is accessible.',
  WARN_PDF_FETCH: 'Unable to fetch PDF. Please check the URL.',
  MUX_UPLOAD_FAILED: 'MUX upload failed. Please try again.',
});

export const PDF_PAGE_REGEX = /\/Type\s*\/Page[^s]/g;

export const STYLES = Object.freeze({
  OVERLAY: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.5)',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: 16,
  },
});